// ============================================
// Path: /frontend/src/pages/AgentDetailPage.jsx
// Purpose: Display agent profile and their listings only
// ============================================

import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { listingsAPI } from '../api/listings.api';
import apiClient from '../api/client';
import { ListingCard } from '../components/ListingCard';
import { Skeleton } from '../components/ui/skeleton';
import { Mail, Phone, Loader2, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import ListingsGrid from '../components/ListingsGrid';


export default function AgentDetailPage() {
  const { id } = useParams();
  console.log('[AgentDetailPage] Opened for agent:', id);
  const navigate = useNavigate();
  const [agent, setAgent] = useState(null);
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      console.log('[AgentDetailPage] Fetching agent and listings...');
      setLoading(true);

      try {
        // Fetch agent details
        console.log('[AgentDetailPage] Getting agent:', id);
        const agentRes = await apiClient.get(`/users/${id}/public`);
        console.log('[AgentDetailPage] Agent received:', agentRes.data.user?.fullName);
        setAgent(agentRes.data.user);

        // Fetch only this agent's listings
        console.log('[AgentDetailPage] Getting listings for agent:', id);
        const listingsRes = await listingsAPI.getUserListings(id);
        console.log('[AgentDetailPage] Listings received:', listingsRes.listings?.length);
        setListings(listingsRes.listings || []);

        setError(null);
      } catch (err) {
        console.error('[AgentDetailPage] Fetch error:', err);
        setError(err.response?.data?.message || 'Failed to load agent details');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  if (loading) {
    return (
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow container py-12">
          <div className="max-w-6xl mx-auto">
            <Skeleton className="h-40 w-40 rounded-full mb-6" />
            <Skeleton className="h-8 w-64 mb-4" />
            <Skeleton className="h-4 w-96 mb-8" />
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {Array.from({ length: 8 }).map((_, i) => (
                <Skeleton key={i} className="h-64 w-full" />
              ))}
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  if (error || !agent) {
    return (
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow flex items-center justify-center">
          <div className="text-center">
            <p className="text-destructive mb-4">{error || 'Agent not found'}</p>
            <a href="/agents" className="text-primary underline hover:no-underline">
              Back to Agents
            </a>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow container py-12">
        <div className="max-w-6xl mx-auto">
         
          <button 
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 mb-6 text-sm hover:text-primary transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Back
          </button>

          {/* Listings Section */}
          
          <ListingsGrid
          listings={listings}
          loading={loading}
          title={`${agent?.fullName || 'Agent'}'s Listings`}
          showFilters={true}
          emptyMessage="This agent has no listings yet"
        />
        </div>
      </main>
      <Footer />
    </div>
  );
}